import { cn } from "@/lib/utils";
import "./heading.css";

const HeroHeading = ({
	className,
	text,
}: {
	className?: string;
	text: { title: string; screenReader: string };
}) => {
	return (
		<h1
			className={cn(
				"mx-auto flex max-w-4xl flex-col items-center justify-center gap-1 rounded-md py-2 text-3xl font-bold max-md:flex-wrap md:gap-0 lg:text-4xl xl:text-5xl",
				className
			)}
		>
			<span>{text.title}</span>

			<div className="text-container h-9 items-center overflow-hidden px-2 text-center text-brand-primary md:h-10 md:text-left lg:h-[3.3rem]">
				<span className="text">Products</span>
				<span className="text">News</span>
				<span className="text">Leaders</span>
				<span className="text">Communities</span>
				<span className="text">Events</span>
			</div>

			{/* For screen readers */}
			<span className="sr-only">{text.screenReader}</span>
		</h1>
	);
};

export default HeroHeading;
